import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { authLogout } from "../../../store/actions/auth";

class Logout extends PureComponent {
  componentDidMount = () => {
    this.props.onLogout();
  };

  render() {
    return <Redirect to="/" />;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: () => dispatch(authLogout()),
  };
};

export default connect(null, mapDispatchToProps)(Logout);
